/**
 * Fleet desk client display — consolidates legacy account labels
 * (Primary, Prime Zerodha, etc.) into one operator-facing name.
 */
export function normalizeClientAlias(alias, clientId) {
    const raw = (alias || clientId || '').trim();
    const lower = raw.toLowerCase();
    if (lower === 'primary' || lower.includes('prime')) {
        return 'Prime';
    }
    return raw || clientId || '—';
}

export function clientColumnKey(instance = {}) {
    return normalizeClientAlias(instance.clientAlias, instance.clientId);
}
